module.exports = __webpack_public_path__ + "static/thankyou_contactform-6c3055745c116d45c8790c150cf7354e.png";